import React from 'react'
import {
    Box,
    Link,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'

const GoogleRecatpcha = ({isStandardLogin, enabledIDPs, isLoginPage}) => {
    const styles = useMultiStyleConfig('GoogleRecaptcha', {enabledIDPs, isLoginPage})

    return (
        <Box>
            {isStandardLogin && !isLoginPage && (
                <Text {...styles.termsText} as="span">
                    <FormattedMessage
                        defaultMessage="By continuing, you agree to our {termsLink} and {privacyLink}."
                        id="login_form.message.terms_privacy"
                        values={{
                            termsLink: (
                                <Link
                                    href="/terms-conditions.html"
                                    {...styles.termsLink}
                                >
                                    <FormattedMessage
                                        defaultMessage="Terms & Conditions"
                                        id="login_form.link.terms_conditions"
                                    />
                                </Link>
                            ),
                            privacyLink: (
                                <Link
                                    href="/privacy-policy.html"
                                    {...styles.termsLink}
                                >
                                    <FormattedMessage
                                        defaultMessage="Privacy Policy"
                                        id="login_form.link.privacy_policy"
                                    />
                                </Link>
                            )
                        }}
                    />
                </Text>
            )}
            <Text {...styles.recaptchaText} as="span">
                <FormattedMessage
                    id="google_recatpcha.message"
                    defaultMessage="This site is protected by reCAPTCHA and the Google <privacyPolicy>Privacy Policy</privacyPolicy> and <termsOfService>Terms of Service</termsOfService> apply"
                    values={{
                        privacyPolicy: (chunks) => (
                            <Link
                                {...styles.recaptchaLink}
                                href="https://policies.google.com/privacy"
                                isExternal
                            >
                                {chunks}
                            </Link>
                        ),
                        termsOfService: (chunks) => (
                            <Link
                                {...styles.recaptchaLink}
                                href="https://policies.google.com/terms"
                                isExternal
                            >
                                {chunks}
                            </Link>
                        )
                    }}
                />
            </Text>
        </Box>
    )
}

export default GoogleRecatpcha
